<template>
  <on-click-outside :do="close">
    <div :class="{ 'is-active': isOpen, 'disabled': disabled }" class="search-select">
      <button
          ref="button"
          class="search-select-input"
          type="button"
          @click="open"
      >
        <span v-if="value !== null">{{ options.find(el => el[valueField] == value) ? options.find(el => el[valueField] == value)[textField] : '' }}</span>
        <span v-else class="search-select-placeholder">{{placeholder ? placeholder : ''}}</span>
      </button>
      <div v-show="isOpen" ref="dropdown" class="search-select-dropdown">
        <input
            ref="search"
            v-model="search"
            class="search-select-search"
            @keydown.esc="close"
            @keydown.up="highlightPrev"
            @keydown.down="highlightNext"
            @keydown.enter.prevent="selectHighlighted"
            @keydown.tab.prevent
        />
        <ul
            v-show="filteredOptions.length > 0"
            ref="options"
            class="search-select-options"
        >
          <li
              v-for="(option, i) in filteredOptions"
              :key="option[valueField]"
              :class="{ 'is-active': i === highlightedIndex }"
              class="search-select-option"
              @click="select(option)"
          >
            {{option[textField] ? option[textField] : ''}}
          </li>
        </ul>
        <div v-show="filteredOptions.length === 0" class="search-select-empty">
          No results found for "{{ search }}"
        </div>
      </div>
    </div>
  </on-click-outside>
</template>

<script>
import OnClickOutside from "./OnClickOutside.vue"

export default {
  components: {
    OnClickOutside
  },
  // props: ["value", "options", "filterFunction", "placeholder", "valueField", "textField"],
  props: {
    value: {type: String | Number, default: 0},
    options: {type: Array, default: []},
    placeholder: {type: String, default: ''},
    valueField: {type: String, default: 'value'},
    textField: {type: String, default: 'text'},
    disabled: {type: Boolean, default: false}
  },
  data() {
    return {
      isOpen: false,
      search: "",
      highlightedIndex: 0
    }
  },
  computed: {
    filteredOptions() {
      return this.applySearchFilter(this.search, this.options)
    }
  },
  methods: {
    open() {
      if (this.isOpen) {
        return
      }
      this.isOpen = true
      this.$nextTick(() => {
        this.$refs.search.focus()
        this.scrollToHighlighted()
      })
    },
    close() {
      if (!this.isOpen) {
        return
      }
      this.isOpen = false
      this.$refs.button.focus()
    },
    select(option) {
      this.$emit("input", option[this.valueField] != undefined ? option[this.valueField] : option)
      this.$emit("change", option[this.valueField] != undefined ? option[this.valueField] : option)
      this.search = ""
      this.highlightedIndex = this.filteredOptions.findIndex(el => el.value == option[this.valueField])
      this.close()
    },
    selectHighlighted() {
      this.select(this.filteredOptions[this.highlightedIndex])
    },
    scrollToHighlighted() {
      this.$refs.options.children[this.highlightedIndex].scrollIntoView({
        block: "nearest"
      })
    },
    highlight(index) {
      this.highlightedIndex = index

      if (this.highlightedIndex < 0) {
        this.highlightedIndex = this.filteredOptions.length - 1
      }

      if (this.highlightedIndex > this.filteredOptions.length - 1) {
        this.highlightedIndex = 0
      }

      this.scrollToHighlighted()
    },
    highlightPrev() {
      this.highlight(this.highlightedIndex - 1)
    },
    highlightNext() {
      this.highlight(this.highlightedIndex + 1)
    },
    applySearchFilter(search, data) {
      return data.filter((soldier) =>
          soldier.text.toLowerCase().includes(search.toLowerCase())
      );
    }
  }
}
</script>
<style scoped>
.disabled {
  user-select: none;
  pointer-events: none;
  background-color: #efefef;
}

.disabled .search-select-input {
  background-color: #efefef;
}

.search-select {
  position: relative;
}

.search-select-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  text-align: left;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  background-color: #fff;
  border-radius: 0.25rem;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  outline: none;
  overflow: hidden;
  border: 1px solid #D7D5DD;
  background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23d8d6de' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 1rem center/10px 10px no-repeat;

  height: 2.142rem;
  font-size: 0.857rem;
}

.search-select-input span {
  color: #7D7A88;
}

.search-select-input:focus {
  outline: 0;
  -webkit-box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5);
  box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5);
}

.search-select-placeholder {
  color: #8795a1;
}

.search-select.is-active .search-select-input {
  -webkit-box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5);
  box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5);
}

.search-select-dropdown {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  position: absolute;
  right: 0;
  left: 0;
  background-color: #FFF;
  padding: 0.5rem;
  border-radius: 0.25rem;
  -webkit-box-shadow: 0 2px 4px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 4px 4px rgba(0, 0, 0, 0.1);
  z-index: 50;
}

.search-select-search {
  display: block;
  margin-bottom: 0.5rem;
  width: 100%;
  padding: 0.5rem 0.75rem;
  background-color: #FFF;
  color: #000;
  border-radius: 0.25rem;
  border: 1px solid #D7D5DD;
}

.search-select-search:focus {
  outline: 0;
}

.search-select-options {
  list-style: none;
  padding: 0;
  position: relative;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  max-height: 14rem;
  margin: 0;
}

.search-select-option {
  padding: 0.5rem 0.75rem;
  color: #000;
  cursor: pointer;
  font-size: 0.9rem;
  border-radius: 0.25rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.search-select-option:hover {
  background-color: #FDE4E4;
  color: #ED4A46;
}

.search-select-option.is-active,
.search-select-option.is-active:hover {
  background-color: #FDE4E4;
  color: #ED4A46;
}

.search-select-empty {
  padding: 0.5rem 0.75rem;
  color: #b8c2cc;
}
</style>>
